var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    _vm._b(
      {
        staticClass: "app-logo"
      },
      "div",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "router-link",
        {
          staticClass: "site-logo-img pt-3",
          attrs: {
            to: {
              name: "dashboard"
            }
          }
        },
        [
          _c("img", {
            attrs: {
              src: _vm.brand.appLogo,
              alt: "GreenGeeks Web Hosting"
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }